module.exports = __webpack_public_path__ + "static/media/after.672f573e.jpg";